import { StyleSheet } from 'aphrodite/no-important';
import { appMaxWidth, children, media, palette } from '../../../util/style-helpers';
import { GenericObject } from '../../models';

export const style: any = (styles: GenericObject) => {
  return StyleSheet.create({
    main: {
      width: '100%',
    },
    topSection: {
      flexGrow: 1,
      padding: '20px 20px 40px 20px',
      margin: 'auto',
    },
    container: {
      maxWidth: appMaxWidth,
      width: '100%',
      margin: 'auto',
    },

    nav: {
      marginBottom: 20,

      [media.desktop]: {
        marginBottom: 57,
      },
    },
    backButton: {
      fontSize: 16,
      fontWeight: 'bold',
      color: '#FFF',
      display: 'inline',
      position: 'relative',

      ':before': {
        content: '""',
        width: 10,
        height: 10,
        marginLeft: 5,
        marginRight: 10,
        display: 'inline-block',
        borderLeft: '3px solid #707070',
        borderTop: '3px solid #707070',
        transform: 'rotate(-45deg)',
        borderColor: palette.red,
        transition: 'all 0.2s linear',
      },

      ':hover:before': {
        marginLeft: 0,
        marginRight: 15,
      },

      [media.tablet]: {
        fontSize: 20,
        ':before': {
          width: 12,
          height: 12,
        },
      },
      [media.desktop]: {
        ':after': {
          content: '""',
          position: 'absolute',
          width: '0%',
          height: 2,
          top: 'calc(100% + 7px)',
          left: 0,
          backgroundColor: palette.red,
          transition: 'width 0.25s linear',
        },
        ':hover:after': {
          width: '100%',
        },
      },
    },
    companySection: {},
    technicalTrackSessionsSection: {
      width: '100%',
      backgroundColor: palette.black,
      padding: '0px 20px',
    },
    technicalTrackSessionsContent: {
      maxWidth: '980px',
      margin: '0px auto',
      padding: '10px 0px',
      [children('h2')]: {
        padding: '20px 0px',
      },
      [media.tablet]: {
        padding: 0,
        [children('h2')]: {
          padding: '30px 0px 40px 0px',
        },
      },
      [media.desktop]: {
        padding: 0,
        [children('h2')]: {
          padding: '46px 0px 30px 0px',
        },
      },
    },
    technicalTrackSessionsGrid: {
      margin: '0 -15px',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      maxWidth: 980,

      [children('> div')]: {
        marginBottom: 30,
      },

      [media.desktop]: {
        justifyContent: 'flex-start',
        [children('> div')]: {
          marginBottom: 25,
        },
      },
    },
    header: {
      marginBottom: 44,

      [media.xl]: {
        marginBottom: 95,
      },
    },
    companyLogo: {
      width: '100%',
    },

    aboutArticle: {
      lineHeight: 1.375,
      color: palette.white,
      fontSize: 16,
      marginBottom: 25,
      flexGrow: 1,

      [children('p') + ':last-child']: {
        marginBottom: 0,
      },
    },

    h2: {
      marginBottom: 12,
      fontSize: 25,
      textAlign: 'center',
      color: palette.red,

      [media.tablet]: {
        fontSize: 35,
      },

      [media.desktop]: {
        textAlign: 'left',
        fontSize: 40,
        marginBottom: 16,
      },
    },

    h3: {
      marginBottom: 10,
      fontSize: 25,

      [media.tablet]: {
        fontSize: 30,
        marginBottom: 15,
      },
    },
    contactSection: {
      borderRadius: 5,
      background: palette.lightGrey,
      padding: 20,
      lineHeight: '22px',
      color: palette.black,

      [children('h4')]: {
        fontSize: 16,
      },

      [children('span')]: {
        fontSize: 16,
      },

      [media.tablet]: {
        display: 'flex',
        padding: '20px 45px',
        flexGrow: 1,
      },

      [media.desktop]: {
        display: 'block',
        padding: '25px 35px',
        flexGrow: 0,
      },
    },
    contactInfoContainer: {
      [media.tablet]: {
        maxWidth: 210,
        flexGrow: 1,
      },
    },

    contactInfo: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: 17,

      [children('> *')]: {
        wordBreak: 'break-word',
      },

      [media.desktop]: {
        marginBottom: 22,
      },
    },

    contactList: {
      flexGrow: 1,
    },

    socialLinks: {
      ':before': {
        display: 'block',
        width: '100%',
        height: 1,
        content: '""',
        background: palette.red,
        margin: '18px 0',
      },

      [children('a') + ':not(:first-child)']: {
        marginLeft: 10,
      },

      [media.tablet]: {
        display: 'flex',

        [children('a') + ':not(:first-child)']: {
          marginLeft: 0,
          marginTop: 25,
        },

        ':before': {
          width: 1,
          height: '100%',
          margin: '0 35px',
        },
      },

      [media.desktop]: {
        display: 'block',

        ':before': {
          width: '100%',
          height: 1,
          margin: '18px 0',
        },

        [children('a') + ':not(:first-child)']: {
          marginLeft: 20,
          marginTop: 0,
        },
      },
    },

    socialLinksInner: {
      display: 'flex',
      alignItems: 'center',

      [children('img')]: {
        height: 38,
      },

      [media.tablet]: {
        display: ' flex',
        flexDirection: ' column',
        justifyContent: ' center',
        minHeight: ' 100%',
        alignItems: 'flex-start',

        [children('img')]: {
          height: 55,
        },
      },

      [media.desktop]: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',

        [children('img')]: {
          height: 35,
        },
      },
    },

    columnWrapper: {
      [media.desktop]: {
        display: 'flex',
      },
    },

    sidebarContent: {
      [media.tablet]: {
        display: 'flex',
        flexDirection: 'row-reverse',
        justifyContent: 'flex-end',
      },

      [media.desktop]: {
        flexDirection: 'column',
        justifyContent: 'flex-start',
        marginLeft: 130,
        width: 310,
        flexShrink: 0,

        [children('> div') + ':not(:first-child)']: {
          marginTop: 20,
        },
      },
    },
    chatBadgeContainer: {
      background: palette.red,
      padding: 20,
      marginBottom: 15,
      borderRadius: 5,

      [media.tablet]: {
        marginBottom: 0,
        marginLeft: 25,
        padding: '25px 40px',
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      },

      [media.desktop]: {
        padding: '20px 25px',
        marginLeft: 0,
      },
    },

    chatBadge: {
      display: 'flex',
      color: '#FFF',
      marginBottom: 34,
      fontWeight: 'bold',
      fontSize: 25,
      alignItems: 'center',
      justifyContent: 'space-between',
      margin: 'auto',

      [children('.email-icon > svg')]: {
        width: 37,
        height: 37,
      },

      [media.tablet]: {
        fontSize: 30,
      },

      [media.desktop]: {
        flexDirection: 'column',

        [children('.email-icon > svg')]: {
          width: 42,
          height: 42,
        },
        [children('.chat-icon > svg')]: {
          width: 61,
          height: 50,
        },
      },
    },

    chatBadgeContent: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      flexBasis: '100%',
    },

    chatBadgeText: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: 15,

      [children('span') + ':not(:first-child)']: {
        marginLeft: 10,
      },

      [media.tablet]: {
        flexDirection: 'column',
        [children('span') + ':not(:first-child)']: {
          marginLeft: 0,
          marginTop: 10,
        },
      },

      [media.desktop]: {
        flexDirection: 'row',
        [children('span') + ':not(:first-child)']: {
          marginLeft: 10,
          marginTop: 0,
        },
      },
    },

    chatButton: {
      background: palette.white,
      color: palette.red,
      fontWeight: 'bold',
      fontSize: 16,
      borderRadius: 5,
      border: 'none',
      padding: '15px 10px',
      textAlign: 'center',

      ':hover': {
        color: palette.red,
        background: '#FFF',
      },

      [media.tablet]: {
        padding: 15,
      },

      [media.desktop]: {
        background: 'transparent',
        color: palette.white,
        border: '1px solid white',
        padding: '5px 20px',
      },
    },

    grid: {
      display: 'flex',
      flexFlow: 'column wrap',
      width: '100%',

      [children('article')]: {
        marginBottom: 22,
      },
    },

    bottomSection: {
      background: palette.lightGrey,
      color: palette.black,
      padding: '45px 20px',
      display: 'flex',
      justifyContent: 'center',

      [children('h2')]: {
        marginBottom: 30,
        fontSize: 25,
        textAlign: 'center',

        [media.tablet]: {
          fontSize: 35,
        },

        [media.desktop]: {
          fontSize: 40,
          marginBottom: 58,
          textAlign: 'left',
        },
      },
    },

    products: {},
  });
};
